import { combineReducers } from 'redux'
import eventReducer from '../../features/event/eventReducer'
import modalReducer from '../common/modals/modalReducer'
import authReducer from '../../features/auth/authReducer'
import asyncReducer from '../async/asyncReducer'
import profileReducer from '../../features/profiles/profileReducer'
import { connectRouter } from 'connected-react-router'

const rootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),
		event: eventReducer,
		modals: modalReducer,
		auth: authReducer,
		async: asyncReducer,
		profile: profileReducer,
	})

export default rootReducer
